import React from 'react'
import "./Experience.css"
import { themeContext } from '../../Context'
import { useContext } from 'react'
function Experience() {
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  return (
    <div className="Experience"  id='Experiance' >
        <div className="Achievements" >
            <div className="circle" style={{color:darkMode? 'black' : ''}}>1+</div>
            <span>Years</span>
            <span className='mob'>Front-End</span>
        </div>
        {/* 2nd */}
        <div className="Achievements">
            <div className="circle" style={{color:darkMode? 'black' : ''}}>2+</div>
            <span>Years</span>
            <span>WordPress</span>
        </div>
        {/* 3rd */}
        <div className="Achievements">
            <div className="circle" style={{color:darkMode? 'black' : ''}}>10+</div>
            <span>Completed</span>
            <span>Work</span>
        </div>
    </div>
  )
}

export default Experience